<table class="table__wrapper">
  <thead>
    <tr class="header__wrapper">
      <th class="header__text px-8">Id</th>
      @if (showUser()) {
        <th class="header__text">Nombre</th>
      }
      <th class="header__text">Riesgo</th>
      @if (showProducer()) {
        <th class="header__text">Productor</th>
      }
      <th class="header__text text-center text-nowrap">Vigencia Hasta</th>
      <th class="header__text text-center">Estado</th>
      <th class="header__text px-8"></th>
    </tr>
  </thead>

  <tbody>
    @for (item of [1, 2, 3, 4, 5]; track item) {
      <tr
        class="body__wrapper"
        [ngClass]="item % 2 === 0 ? 'bg-gray-50' : 'bg-white'">
        <td class="id__cell">
          <div class="h-4 skeleton__wrapper w-16"></div>
        </td>
        @if (showUser()) {
          <td>
            <div class="flex items-center">
              <div
              class="h-10 w-10 skeleton__wrapper rounded-full mr-3"></div>
              <div class="flex flex-col space-y-1">
                <div class="h-4 skeleton__wrapper w-32"></div>
                <div class="h-3 skeleton__wrapper w-24"></div>
              </div>
            </div>
          </td>
        }
        <td>
          <div class="flex items-center">
            <div class="h-6 w-6 skeleton__wrapper mr-2"></div>
            <div class="h-4 skeleton__wrapper w-20"></div>
          </div>
        </td>
        @if (showProducer()) {
          <td>
            <div class="h-4 skeleton__wrapper w-28"></div>
          </td>
        }
        <td class="text-center">
          <div class="h-4 skeleton__wrapper w-24 mx-auto"></div>
        </td>
        <td class="flex justify-center items-center h-20">
          <div class="h-6 skeleton__wrapper w-20"></div>
        </td>
        <td class="text-center">
          <div class="h-4 skeleton__wrapper w-16 mx-auto"></div>
        </td>
      </tr>
    }
  </tbody>
</table>
